{
  let disabled = false

  // Respect reduced motion preferences - if enabled, don't use sticky/reveal behavior
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  // Get admin bar height if present
  function getAdminBarHeight() {
    const adminBar = document.getElementById('wpadminbar')
    return adminBar ? adminBar.offsetHeight : 0
  }

  // Setting this as a top level function to allow other blocks to call it if needed
  // (e.g., when clicking an anchor link, we don't want the header to hide)
  window.tempDisableHeader = function(){
    disabled = true
    setTimeout(() => disabled = false, 1000)
  }

  // Create a placeholder element to push down body content
  let placeholder = null
  function createPlaceholder(wrapper) {
    placeholder = document.createElement('div')
    placeholder.classList.add('main-header-wrapper--placeholder')
    wrapper.parentNode.insertBefore(placeholder, wrapper)
    updatePlaceholderHeight(wrapper)
  }

  function updatePlaceholderHeight(wrapper) {
    if(placeholder && wrapper) {
      placeholder.style.height = wrapper.offsetHeight + 'px'
    }
  }

  function initHeader() {
    handleRevealHeader()
    handleStickyHeader()
    setScrollOffset()
  }

  function handleRevealHeader(){
    const wrapper = document.querySelector('.main-header-wrapper.reveal')
    if(!wrapper || prefersReducedMotion) {
      // If reduced motion, remove the reveal class so it stays static
      if(wrapper && prefersReducedMotion) {
        wrapper.classList.remove('reveal')
      }
      return
    }

    // Create placeholder to push down content
    createPlaceholder(wrapper)

    let lastScrollPos = 0
    const adminBarHeight = getAdminBarHeight()

    // Set the top position accounting for admin bar
    wrapper.style.top = adminBarHeight + 'px'
    
    // Set CSS variable for hide transform to account for admin bar
    wrapper.style.setProperty('--admin-bar-height', adminBarHeight + 'px')

    // Disable header hide on click (e.g., for anchor links)
    document.addEventListener('click', () => {
      tempDisableHeader()
    })

    window.addEventListener('scroll', () => {
      if(disabled) return

      const scrollY = window.scrollY
      const headerHeight = wrapper.offsetHeight

      // Hide header when scrolling down past the header height
      if(scrollY > headerHeight && lastScrollPos < scrollY){
        wrapper.classList.add('hide')
      } else {
        wrapper.classList.remove('hide')
      }

      // Add compressed class when scrolled past header height
      if(scrollY > headerHeight){
        wrapper.classList.add('compressed')
      } else {
        wrapper.classList.remove('compressed')
      }

      lastScrollPos = scrollY
    })
  }

  function handleStickyHeader(){
    const wrapper = document.querySelector('.main-header-wrapper.sticky')
    if(!wrapper || prefersReducedMotion) {
      // If reduced motion, remove the sticky class so it stays static
      if(wrapper && prefersReducedMotion) {
        wrapper.classList.remove('sticky')
      }
      return
    }

    // Create placeholder to push down content
    createPlaceholder(wrapper)

    const adminBarHeight = getAdminBarHeight()
    wrapper.style.top = adminBarHeight + 'px'
    
    window.addEventListener('scroll', () => {
      if(window.scrollY > wrapper.offsetHeight){
        wrapper.classList.add('compressed')
      } else {
        wrapper.classList.remove('compressed')
      }
    })
  }

  function setScrollOffset(){
    const wrapper = document.querySelector('.main-header-wrapper.reveal, .main-header-wrapper.sticky')
    if(wrapper && !prefersReducedMotion){
      const offset = wrapper.offsetHeight + getAdminBarHeight()
      document.documentElement.style.scrollPaddingTop = `${offset}px`
    }
  }

  // Initialize after a short delay to ensure DOM is ready
  setTimeout(initHeader, 10)
  
  // Recalculate after full page load (images, fonts, etc.)
  window.addEventListener('load', () => {
    const wrapper = document.querySelector('.main-header-wrapper.reveal, .main-header-wrapper.sticky')
    if(wrapper && !prefersReducedMotion) {
      updatePlaceholderHeight(wrapper)
      setScrollOffset()
    }
  })

  window.addEventListener('resize', () => {
    const wrapper = document.querySelector('.main-header-wrapper.reveal, .main-header-wrapper.sticky')
    if(wrapper && !prefersReducedMotion) {
      updatePlaceholderHeight(wrapper)
      setScrollOffset()
    }
  })
}
